import React, { useState } from 'react';
import { ButtonPrimary, Spinner } from '../StyledComponent';
import FacebookInput from './FacebookInput';
import InstagramInput from './InstagramInput';

import HeaderSection from '../HeaderSection';
import { ContainerFields } from './styles';

const SocialMedias = ({
  tema,
  setUserDataCopy,
  isUserDataEqualsUserDataCopy,
  userDataCopy,
  haveAnyFieldsEditing,
  toggleEdit,
  handleCancel,
  onClickSave,
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  async function handleSave() {
    onClickSave(setIsEditable, setIsLoading);
  }

  return (
    <div>
      <HeaderSection
        title={'Redes sociais'}
        subtitle={
          'Adicione abaixo os perfis das redes sociais que você mais utiliza:'
        }
        tema={tema}
        isEditable={isEditable}
        setIsEditable={setIsEditable}
        onEdit={toggleEdit}
        onCancel={handleCancel}
        haveAnyFieldsEditing={haveAnyFieldsEditing}
        isLoading={isLoading}
      />
      <ContainerFields>
        <div className='field'>
          <FacebookInput
            value={userDataCopy?.Facebook}
            setValue={setUserDataCopy}
            userData={userDataCopy}
            isEditable={isEditable}
          />
        </div>
        <div className='field'>
          <InstagramInput
            value={userDataCopy?.Instagram}
            setValue={setUserDataCopy}
            userData={userDataCopy}
            isEditable={isEditable}
          />
        </div>
      </ContainerFields>
      {isEditable && (
        <ButtonPrimary
          fullWidth
          disabled={isUserDataEqualsUserDataCopy || isLoading}
          tema={tema}
          onClick={handleSave}
        >
          SALVAR ALTERAÇÕES
          {isLoading && <Spinner />}
        </ButtonPrimary>
      )}
    </div>
  );
};

export default SocialMedias;
